var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNestCondition = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.31 12.166 2.515 2.598a.76.76 0 0 1 .197.5.76.76 0 0 1-.178.51.63.63 0 0 1-.452.225.62.62 0 0 1-.467-.186L3.206 11.97a.7.7 0 0 1-.152-.239.78.78 0 0 1 0-.571.7.7 0 0 1 .152-.239l3.72-3.843a.7.7 0 0 1 .216-.154.6.6 0 0 1 .508.011.7.7 0 0 1 .211.165q.091.106.137.241a.79.79 0 0 1-.02.557.7.7 0 0 1-.153.23L5.31 10.724h8.845c.406 0 .796-.177 1.083-.492.287-.316.448-.743.448-1.19V4.722c0-.192.07-.375.193-.51A.63.63 0 0 1 16.344 4c.174 0 .34.076.464.211a.76.76 0 0 1 .192.51v4.323c0 .828-.3 1.622-.833 2.208-.533.585-1.257.914-2.01.914z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNestCondition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nest-condition.68492f5c.svg";